import { afterMarketService } from '@/services/after-market/after-market-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toValue, type MaybeRefOrGetter } from 'vue';
import type { AfterMarketRow } from '../types';

export const useAfterMarketTableMutation = (
  projectId: MaybeRefOrGetter<string>,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (rows: AfterMarketRow[]) =>
      afterMarketService.replaceAll(
        toValue(projectId),
        rows.map(({ text, date }) => ({ text, date: date || null })),
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.afterMarket({ projectId: toValue(projectId) }),
      });
    },
  });
};
